import { render, staticRenderFns } from "./ProvidersSlider.vue?vue&type=template&id=3959644c&scoped=true"
import script from "./ProvidersSlider.vue?vue&type=script&lang=js"
export * from "./ProvidersSlider.vue?vue&type=script&lang=js"
import style0 from "./ProvidersSlider.vue?vue&type=style&index=0&id=3959644c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959644c",
  null
  
)

export default component.exports